<script setup>
import { AppDropdown, AppDropdownItem } from '@/components/molecules/AppDropdown'
import { useNotificationsStore } from '@/stores/NotificationsStore'
import { useRouter } from 'vue-router'

const notificationsStore = useNotificationsStore()
const router = useRouter()

const handleViewAllNotifications = () => {
  router.push('/notifications')
}
</script>
<template>
  <!-- `portal` teleports the menu to <body> so it isn't clipped by the
       notifications panel's overflow (few-items case). -->
  <AppDropdown portal placement="bottom-end" width="w-56">
    <template #trigger>
      <button
        type="button"
        class="block w-fit mx-auto p-1.5 rounded-lg transition duration-300 hover:bg-gray-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-300"
      >
        <Icon icon="heroicons:ellipsis-vertical-20-solid" class="text-xl" />
      </button>
    </template>

    <AppDropdownItem 
      icon="heroicons:eye-20-solid" 
      @select="handleViewAllNotifications"
      itemClass="text-sm hover:bg-gray-100 !text-gray-900"
      iconClass="text-gray-900"
    >
      View All Notifications
    </AppDropdownItem>
    <AppDropdownItem
      icon="heroicons:trash-20-solid"
      danger
      @select="notificationsStore.clearAllNotifications"
      itemClass="text-sm hover:bg-gray-100 !text-red-600"
      iconClass="text-red-600"
    >
      Clear All
    </AppDropdownItem>
  </AppDropdown>
</template>
